
























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import { contextModule } from "@/store/context";
import InfiniteLoading from "vue-infinite-loading";
import ILabel from "@/types/label";
import studioFragment from "@/fragments/studio";
import StudioCard from "@/components/StudioCard.vue";
import { mixins } from "vue-class-component";
import DrawerMixin from "@/mixins/drawer";
import { studioModule } from "@/store/studio";

@Component({
  components: {
    InfiniteLoading,
    StudioCard,
  },
})
export default class StudioList extends mixins(DrawerMixin) {
  get showSidenav() {
    return contextModule.showSidenav;
  }

  rerollSeed() {
    const seed = Math.random().toString(36);
    localStorage.setItem("pm_seed", seed);
    if (this.sortBy === "$shuffle") this.loadPage(this.page);
    return seed;
  }

  studios = [] as any[];

  fetchLoader = false;
  fetchError = false;
  fetchingRandom = false;

  studiosBulkText = "" as string | null;
  bulkImportDialog = false;
  bulkLoader = false;

  get showCardLabels() {
    return contextModule.showCardLabels;
  }

  async runBulkImport() {
    this.bulkLoader = true;

    try {
      for (const name of this.studiosBulkImport) {
        await this.createStudioWithName(name);
      }
      this.refreshPage();
      this.bulkImportDialog = false;
    } catch (error) {
      console.error(error);
    }

    this.studiosBulkText = "";
    this.bulkLoader = false;
  }

  get studiosBulkImport() {
    if (this.studiosBulkText) return this.studiosBulkText.split("\n").filter(Boolean);
    return [];
  }

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  allLabels = [] as ILabel[];
  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_studioInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_studioExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_studioInclude", val.include.join(","));
    localStorage.setItem("pm_studioExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  query = localStorage.getItem("pm_studioQuery") || "";

  set page(page: number) {
    studioModule.setPage(page);
  }

  get page() {
    return studioModule.page;
  }

  get numResults() {
    return studioModule.numResults;
  }

  get numPages() {
    return studioModule.numPages;
  }

  sortDir = localStorage.getItem("pm_studioSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_studioSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "# scenes",
      value: "numScenes",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    /* {
      text: "Rating",
      value: "rating"
    } */
  ];

  favoritesOnly = localStorage.getItem("pm_studioFavorite") == "true";
  bookmarksOnly = localStorage.getItem("pm_studioBookmark") == "true";

  labelIDs(indices: number[]) {
    return indices.map((i) => this.allLabels[i]).map((l) => l._id);
  }

  labelNames(indices: number[]) {
    return indices.map((i) => this.allLabels[i].name);
  }

  async createStudioWithName(name: string) {
    try {
      const res = await ApolloClient.mutate({
        mutation: gql`
          mutation($name: String!) {
            addStudio(name: $name) {
              ...StudioFragment
              numScenes
              thumbnail {
                _id
              }
              labels {
                _id
                name
              }
              parent {
                _id
                name
              }
            }
          }
          ${studioFragment}
        `,
        variables: {
          name,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  studioLabels(studio: any) {
    return studio.labels.map((l) => l.name).sort();
  }

  refreshed = true;

  resetPagination() {
    studioModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("ratingFilter", {})
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_studioRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_studioFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_studioBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_studioSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_studioSortBy", newVal);
    this.refreshed = false;
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_studioQuery", newVal || "");
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    studioModule.resetPagination();
    this.loadPage(this.page);
  }

  getRandom() {
    this.fetchingRandom = true;
    this.fetchPage(1, 1, true, Math.random().toString())
      .then((result) => {
        // @ts-ignore
        this.$router.push(`/studio/${result.items[0]._id}`);
      })
      .catch((err) => {
        this.fetchingRandom = false;
      });
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: StudioSearchQuery!, $seed: String) {
            getStudios(query: $query, seed: $seed) {
              items {
                ...StudioFragment
                numScenes
                thumbnail {
                  _id
                }
                labels {
                  _id
                  name
                }
                parent {
                  _id
                  name
                }
              }
              numItems
              numPages
            }
          }
          ${studioFragment}
        `,
        variables: {
          query: {
            query: this.query || "",
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            take,
            page: page - 1,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getStudios;
    } catch (err) {
      throw err;
    }
  }

  loadPage(page: number) {
    this.fetchLoader = true;

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        studioModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.studios = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  refreshPage() {
    this.loadPage(studioModule.page);
  }

  mounted() {
    if (!this.studios.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
        }
      `,
    })
      .then((res) => {
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
